import toStream from 'rdf-dataset-ext/toStream.js';
import fromStream from 'rdf-dataset-ext/fromStream.js';
import toCanonical from 'rdf-dataset-ext/toCanonical.js';
import DatasetFactory from './DatasetFactory.js';
export default (createConstructor) => class extends DatasetFactory(createConstructor) {
    init() {
        super.init();
        this.dataset.toCanonical = toCanonical;
        this.dataset.toStream = toStream;
        this.dataset.fromStream = (stream) => {
            return fromStream(this.dataset(), stream);
        };
    }
};
